<template>
    <a :href="href" target="_system" @click="open" ><slot></slot></a>
</template>
<script>
export default {
    props: ['href'],
    methods: {
        open(e) {
            if ('undefined' != typeof window.cordova) {            
                e.preventDefault();
                e.stopPropagation();
                cordova.InAppBrowser.open(this.href, '_system');
            }
        }
    }
}
</script>